import { collection, query, where, getDocs, deleteDoc, doc, getDoc } from 'firebase/firestore';
import { db } from '../../../config';
import { handleFirebaseError } from '../../../error-handling';

export async function removeExaminerFromOrganization(
  organizationId: string,
  examinerId: string
): Promise<boolean> {
  try {
    const memberId = `${organizationId}_${examinerId}_examiner`;
    const memberRef = doc(collection(db, 'organizationMembers'), memberId);
    const existing = await getDoc(memberRef);
    if (existing.exists()) {
      await deleteDoc(memberRef);
      return true;
    }

    // Fallback: legacy duplicates cleanup
    const memberQuery = query(
      collection(db, 'organizationMembers'),
      where('organizationId', '==', organizationId),
      where('userId', '==', examinerId),
      where('role', '==', 'examiner')
    );
    const snapshot = await getDocs(memberQuery);
    if (!snapshot.empty) {
      await Promise.all(snapshot.docs.map(d => deleteDoc(d.ref)));
      return true;
    }
    
    return false;
  } catch (error) {
    handleFirebaseError(error, 'Error removing examiner from organization');
    return false;
  }
} 